<template>
  <v-form ref="projectForm" v-model="valid" :lazy-validation="lazy">
    <v-row dense>
      <v-col cols="12" md="12">
        <v-text-field
          autocomplete="off"
          type="text"
          outlined
          dense
          :rules="inputRules"
          label="Project Title"
          v-model="record.name"
        ></v-text-field>
      </v-col>

      <v-col cols="12" md="3">
        <v-autocomplete
          autocomplete="off"
          hide-details
          dense
          :rules="inputRules"
          outlined
          v-model="record.scale"
          :items="scales"
          label="Scale"
          item-text="Name"
          item-value="id"
        ></v-autocomplete>
      </v-col>

      <v-col cols="12" md="3">
        <v-autocomplete
          autocomplete="off"
          hide-details
          dense
          :rules="inputRules"
          outlined
          v-model="record.projectLead"
          :items="employees"
          label="Project Lead"
          item-text="name"
          item-value="id"
        ></v-autocomplete>
      </v-col>

      <v-col cols="12" md="3">
        <DatePicker
          class="mt-2"
          @date="setDate"
          :myDate="date"
          :title="`Date`"
          ref="dateRef"
        ></DatePicker>
      </v-col>

      <v-col cols="12" md="3">
        <v-text-field
          autocomplete="off"
          type="text"
          outlined
          dense
          :rules="inputRules"
          label="Start Time"
          v-model="record.startTime"
        ></v-text-field>
      </v-col>

      <v-col cols="12">
        <v-btn
          v-if="docCreate == true"
          color="primary"
          @click="sendData"
          :loading="$store.state.btnLoader"
        >
          <v-icon left>mdi-content-save</v-icon>Save
        </v-btn>

        <v-btn
          v-else
          color="primary"
          @click="sendData"
          :loading="$store.state.btnLoader"
        >
          <v-icon left>mdi-content-save</v-icon>Update
        </v-btn>
      </v-col>
    </v-row>
    <snackbar ref="snackbar"></snackbar>
  </v-form>
</template>

<script>
export default {
  props: {
    initial: {
      type: Object,
      required: true,
    },
    docCreate: {
      type: Boolean,
    },
  },
  data: () => ({
    lazy: false,
    valid: false,
    inputRules: [(v) => !!v || "Required"],
    record: {},
    loader: false,
    scales: [],
    employees: [],
    date: new Date().toISOString().substr(0, 10),
  }),
  computed: {
    activeStore() {
      return localStorage.getItem("store_id");
    },
  },
  watch: {
    initial: {
      handler: "init",
      immediate: true,
    },
  },
  methods: {
    init(val) {
      this.record = { ...val };
    },
    setDate(date) {
      this.date = date;
    },
    sendData() {
      if (!this.$refs.projectForm.validate()) {
        this.$refs.snackbar.show("Please fill all the fields", "red");
        return;
      }
      const store_id = this.activeStore;
      this.record.date = this.date;
      this.record.store_id = parseInt(store_id);
      this.$store.commit("btnLoader", true);
      this.$emit("data", this.record);
    },
    getScales() {
      const self = this;
      this.$store
        .dispatch("get", `/scales`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.scales = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getEmployees() {
      const self = this;
      this.$store
        .dispatch("get", `/employees`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.employees = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    this.getScales();
    this.getEmployees();
  },
};
</script>
